module.exports = __webpack_public_path__ + "img/imagenDosSalud.39b280c7.png";